import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LanguageStepProps {
  onLanguageSelect: (lang: 'pt' | 'en') => void;
}

export function LanguageStep({ onLanguageSelect }: LanguageStepProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-3 sm:space-y-4">
      <h2 className="text-lg sm:text-xl font-semibold text-center">Seleciona o idioma preferido</h2>
      <div className="grid grid-cols-1 gap-2 sm:gap-3">
        <Button
          variant="outline"
          className="w-full py-6 text-lg flex items-center justify-center gap-2"
          onClick={() => onLanguageSelect('pt')}
        >
          <Globe className="h-5 w-5" />
          Português
        </Button>
        <Button
          variant="outline"
          className="w-full py-6 text-lg flex items-center justify-center gap-2"
          onClick={() => onLanguageSelect('en')}
        >
          <Globe className="h-5 w-5" />
          English
        </Button>
      </div>
    </div>
  );
}